import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/telematch.webp';
import screenshot_target from '../../../images/letterfunnel/aartvangeemert.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Aart van Geemert"
      firstname="Aart"
      companyname="Telematch"
      competition="Dstny en Gamma Communications"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/aartvangeemert.js